export default "__VITE_ASSET__fd8bc92b__"